export default "__VITE_ASSET__CB4al2Hb__"